import { TemplateRef, NgZone } from '@angular/core';
import { Validators, FormBuilder } from '@angular/forms';
import { UserService } from './../../services/user.service';
import { FormService } from '../../services/form.service';
import { RutValidator } from 'ng2-rut';
import { MatDialog, MatDialogRef } from 'node_modules/@angular/material';
import { RegistroComponent } from './registro/registro.component';
import * as _rut from 'rut-helpers';
import { Router } from '@angular/router';
import { NgxSpinnerService } from 'ngx-spinner';
import { ClaveUnicaService } from 'src/app/services/clave_unica.service';
import { DomSanitizer } from '@angular/platform-browser';
import { emailValidator } from '../../services/match';
import { GLOBAL } from 'src/app/services/global';
var HomeComponent = /** @class */ (function () {
    function HomeComponent(_userService, rutValidator, fb, dialog, _router, zone, spinner, claveUnicaService, sanitizer, dialogRef, data) {
        this._userService = _userService;
        this.fb = fb;
        this.dialog = dialog;
        this._router = _router;
        this.zone = zone;
        this.spinner = spinner;
        this.claveUnicaService = claveUnicaService;
        this.sanitizer = sanitizer;
        this.dialogRef = dialogRef;
        this.data = data;
        this.matcher = new FormService();
        this.regexp = new RegExp(/^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/);
        this.url = data.url;
        this.user = this.fb.group({
            rut: ['', [Validators.required, rutValidator, Validators.minLength(8)]],
            password: ['', [Validators.required]]
        });
        this.new = this.fb.group({
            rut: ['', [Validators.required, rutValidator]],
            email: ['', [Validators.pattern(this.regexp), Validators.required, Validators.maxLength(50)]],
            repeatEmail: ['', [Validators.pattern(this.regexp), Validators.required, Validators.maxLength(50)]]
        }, {
            validator: emailValidator.match
        });
        this.mail = '';
    }
    HomeComponent.prototype.login = function (user) {
        var _this = this;
        var url = localStorage.getItem("navdomcloud");
        this.spinner.show();
        this._userService.login(_rut.rutClean(this.user.value.rut), this.user.value.password).subscribe(function (response) {
            _this.identity = response.user;
            if (!_this.identity) {
                alert("Usuario incorrecto");
            }
            else {
                sessionStorage.setItem("identity-domCloud", JSON.stringify(_this.identity));
                if (response.token) {
                    _this.token = response.token;
                    if (_this.token.length <= 0) {
                        console.error("No se ha generado el token");
                    }
                    else {
                        sessionStorage.setItem("token-domCloud", _this.token);
                        sessionStorage.setItem("activeCertificado", "true");
                        _this.dialog.closeAll();
                        _this.spinner.hide();
                        _this._router.navigate(["/" + _this.url]);
                    }
                }
            }
        }, function (error) {
            var e = JSON.parse(error._body);
            _this.spinner.hide();
        });
    };
    HomeComponent.prototype.register = function () {
        this.dialogRef.close();
        this.dialog.open(RegistroComponent, {
            id: "logindialog",
            width: '50vw',
            height: 'auto',
        });
    };
    HomeComponent.prototype.claveunica = function () {
        var _this = this;
        this.spinner.show();
        this.dialog.closeAll();
        this.claveUnicaService.getToken().subscribe(function (response) {
            var externalUrl = response.url;
            console.log("External url: ", externalUrl);
            var urlObj = new URL(externalUrl);
            var state = urlObj.searchParams.get('state');
            sessionStorage.setItem('authState', state);
            var route = sessionStorage.getItem('selected-route');
            var datos = { state: state, env: GLOBAL.env, route: route };
            _this.claveUnicaService.guardarDatos(datos).subscribe(function (response) {
                console.log('Token generado:', response.token);
                _this.spinner.hide();
                window.open(externalUrl, '_self'); //, '_blank'
            }, function (error) {
                console.error('Error al guardar datos de la sesion:', error);
            });
        });
    };
    HomeComponent.prototype.openResend = function () {
        this.dialog.open(this.openModalResend);
    };
    HomeComponent.prototype.openPass = function () {
        this.dialog.open(this.openResetPass);
    };
    HomeComponent.prototype.submitRepeatPass = function () {
        var _this = this;
        console.log(this.new);
        var withoutSpaces = (this.new.value.repeatEmail).replace(/\ /g, "");
        console.log(withoutSpaces);
        this._userService.sendMailResetPass(this.new.value.rut, withoutSpaces).subscribe(function (resp) {
            if (resp.status == 'ok') {
                _this.spinner.hide();
                _this.dialog.closeAll();
                _this.dialog.open(_this.mailResp);
            }
            else {
                _this.spinner.hide();
                alert(resp.message);
            }
        });
    };
    HomeComponent.prototype.resendMail = function () {
        var _this = this;
        this.spinner.show();
        this._userService.resendMailActivation(this.mail).subscribe(function (response) {
            if (response.message) {
                alert("Correo de activación reenviado");
                _this.dialog.closeAll();
                _this.spinner.hide();
            }
        }, function (error) {
            var e = JSON.parse(error._body);
            _this.spinner.hide();
        });
    };
    return HomeComponent;
}());
export { HomeComponent };
